import React from 'react';

import Link from 'atomic/link/link';
import Icon from 'atomic/icon/icon';
import { CompanyInterface } from 'interfaces/company.interface';

interface CompanyViewCardRatingBlankProps {
    company: CompanyInterface;
    description?: string;
}

const CompanyViewCardRatingBlank: React.FC<CompanyViewCardRatingBlankProps> = ({ company, description }) => (
    <div className="company-view-card__rating company-view-card__rating-blank">
        <Icon icon="shop" className="company-view-card__rating-blank-icon" />
        <p>
            Jeśli jesteś właścicielem sklepu
            {''}
            <br />
            {''}
            dołącz do programu
        </p>
        <Link href="https://dolacz.opineo.pl/" target="_blank" type="button"
            color="green" uppercase={true}
        >
            Dołącz do programu
        </Link>

        {description && (
            <div className="company-view-card__opineo-description">
                <h2 className="company-view-card__opineo-header">
                    {company.name}
                    {' '}
                    - o
                    {' '}
                    {company.type === 'shop' ? 'sklepie' : 'firmie'}
                </h2>
                <p className="company-view-card__opineo-text" dangerouslySetInnerHTML={{ __html: description }} />
            </div>
        )}
    </div>
);

export default CompanyViewCardRatingBlank;
